import {
  moveToLogin,
  trackEvent,
  getChipsUid,
  getInsetTop,
  calc,
  showBottomSheet,
} from "../../js/chips-common.js";
import "./Fruits.scss";
import "../../assets/fonts/font.css";
import React, { useEffect, useState } from "react";
import { encryptText } from "../../util/JSEncrypt";
import { OutlineText } from "../../component/OutlineText";
import chipsApi from "../../js/chips-api";
import { WinnersDisplay } from "./component/WinnersDisplay";
import { WatermelonImagePopup } from "./component/WatermelonImagePopup";
import { WatermelonPopup } from "./component/WatermelonPopup";
import { WatermelonPlayNoticePopup } from "./component/WatermelonPlayNoticePopup";
import { LeaderboardPopup } from "./component/LeaderboardPopup";
import { DrawHistoriesPopup } from "./component/DrawHistoriesPopup";
import { MissionsBottomSheet } from "./component/MissionsBottomSheet";
import { MissionsBottomSheetContent } from "./component/MissionsBottomSheetContent";
import ReactDOM from "react-dom";
import { PrizeGroups } from "./component/PrizeGroups";
import { ChipsPopupContainer } from "./component/ChipsPopupContainer";
import { share } from "../../util/Sharer";
import { WinnersPopup } from "./component/WinnersPopup";
import { useScript } from "../../util/UseScript";

function Fruits(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const [drawOpportunityCount, setDrawOpportunityCount] = useState(0);
  const [specialDrawOpportunityCount, setSpecialDrawOpportunityCount] =
    useState(0);
  const [prizeGroups, setPrizeGroups] = useState([]);
  const [prizeGroup, setPrizeGroup] = useState({});
  const [missions, setMissions] = useState([]);
  const [winningDisplays, setWinningDisplays] = useState([]);

  const [isPlay, setPlay] = useState(false);
  const [isLoaded, setLoaded] = useState(false);
  const [isSuccessToast, setSuccessToast] = useState(false);
  const [isShowGameOverLayer, setShowGameOverLayer] = useState(false);
  const [gameOverTitle, setGameOverTitle] = useState("게임 오버..");
  const [gameScore, setGameScore] = useState("");
  const [waitingGameStart, setWaitingGameStart] = useState(false);
  const [isEndedEvent, setEndedEvent] = useState(false);

  useScript("/games/fruits-merge/box2d.wasm.js");
  useScript("/games/fruits-merge/scripts/supportcheck.js");
  useScript("/games/fruits-merge/scripts/main.js");

  function isShowPlayContainer() {
    return (
      document.querySelector(".play-container")?.style?.display === "block"
    );
  }

  const handleMoveGame = () => {
    window.location.href = 'chips://web?has_header=false&fullscreen=true&login_required=true&url=https%3A%2F%2Fcashhub.nbt.com%2Fstepfield%2Fgame%3Ffrom%3Dfruits'
  }

  const mainVisibilityChange = () => {
    if (!document.hidden && !isShowPlayContainer()) {
      try {

        const today = new Date();

        //2월 1일 이후로 변경
        const eventEndDate = new Date("2024-02-01T00:00:00");
        if (today > eventEndDate) {
          setEndedEvent(true);
        }

        // eslint-disable-next-line no-undef
        chipsApp.setThemeColor("#FFF0BF");

        // eslint-disable-next-line no-undef
        chipsApp.showHeader(false);

        // eslint-disable-next-line no-undef
        chipsApp.setFullscreen(true);
      } catch (e) {}

      // 페이지가 트랜지션 과정에서 active 상태로 잡히는 경우가 있어서
      // 500ms 이후 페이지가 active 상태인 경우에만 새로고침 함
      setTimeout(() => {
        if (!document.hidden && !isShowPlayContainer()) {
          getGameWatermelonWithShareMissionComplete();
        }
      }, 500);
    }
  };

  useEffect(() => {
    let timeoutId;
    if (waitingGameStart) {
      // 게임이 초기화되면 10초 후에 타임아웃 설정
      timeoutId = setTimeout(() => {
        trackEvent("game_start_timeout");
        try {
          // eslint-disable-next-line no-undef
          showBottomSheet({
            icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
            title: "게임 실행이 어려워요 :(",
            body: "이용에 불편 드려 죄송합니다.<br/>도전권은 차감되지 않았어요.<br/>나중에 다시 사용해 주세요.",
            secondary_button_text: "확인",
            secondary_button_style: "secondary",
            secondary_button_callback: "window.location.reload(true)",
          });
        } catch (e) {}
      }, 10000);
    }

    // cleanup 함수에서 타임아웃 제거
    return () => {
      clearTimeout(timeoutId);
    };
  }, [waitingGameStart]); // gameLoaded 상태가 변경될 때마다 실행

  useEffect(() => {
    window.moveToLogin = moveToLogin;

    try {
      const today = new Date();

      //2월 1일 이후로 변경
      const eventEndDate = new Date("2026-02-01T00:00:00");
      if (today > eventEndDate) {
        setEndedEvent(true);
      }
      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#FFF0BF");

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(false);

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(true);
    } catch (e) {}

    const loadedTime = localStorage.getItem("loaded_time");
    if (!loadedTime || Date.now() - parseInt(loadedTime) > 10 * 60 * 1000) {
      localStorage.setItem("loaded_time", Date.now().toString());
      if (loadedTime) {
        window.location.reload(true);
        return;
      }
    }

    document.removeEventListener("visibilitychange", mainVisibilityChange);
    document.addEventListener("visibilitychange", mainVisibilityChange);
    getGameWatermelonWithShareMissionComplete();

    new Promise((onload, reject) => {
      const src = "https://t1.kakaocdn.net/kakao_js_sdk/2.1.0/kakao.min.js";
      const integrity =
        "sha384-dpu02ieKC6NUeKFoGMOKz6102CLEWi9+5RQjWSV0ikYSFFd8M3Wp2reIcquJOemx";
      const crossOrigin = "anonymous";
      const script = document.createElement("script");
      script.integrity = integrity;
      script.crossOrigin = crossOrigin;
      const onerror = (evt) =>
        reject(URIError(`스크립트 로딩 실패 ${evt.target.src}`));
      Object.assign(script, { type: "text/javascript", onload, onerror, src });
      document.head.appendChild(script);
    }).then(() => window.Kakao.init("e70756f39b9983141207090ae7dac505"));
  }, []);

  function showMissionsBottomSheet() {
    MissionsBottomSheet({
      drawOpportunityCount: drawOpportunityCount,
      specialDrawOpportunityCount: specialDrawOpportunityCount,
      missions: missions,
      mission: onClickMission,
    });
  }

  function onClickMission(mission) {
    trackEvent("mission_cta", {
      id: mission.id.toString(),
      title: mission.name,
    });

    if (getChipsUid()) {
      switch (mission.type) {
        case "1":
          shareKakao();
          break;

        case "2":
          shareText();
          break;

        default:
          completeMission(mission);
          break;
      }
    } else {
      showLoginBottomSheet();
    }
  }

  function getGameWatermelon(callback) {
    chipsApi.request({
      method: "get",
      url: `${domain}/api/v1/benefit-events/game_watermelon`,
      then: (response) => {
        const data = response.data;
        setGameWatermelon(data);

        if (callback) {
          callback(data);
        }
      },
    });
  }

  function setGameWatermelon(data) {
    const prizeGroups = data.prize_groups;
    const winningDisplays = data.prize_winning_users;
    const drawOpportunityCount = data.draw_opportunity_count;
    const specialDrawOpportunityCount = data.special_draw_opportunity_count;
    const missions = data.benefit_event_missions;

    setPrizeGroups(prizeGroups);
    setWinningDisplays(winningDisplays);
    setDrawOpportunityCount(drawOpportunityCount);
    setSpecialDrawOpportunityCount(specialDrawOpportunityCount);
    setMissions(missions);

    // default selected prize group
    if (!prizeGroup?.id && prizeGroups) {
      const defaultPrizeGroup = prizeGroups[prizeGroups.length === 3 ? 1 : 0];
      const prizeGroup =
        defaultPrizeGroup.status !== 2
          ? defaultPrizeGroup
          : prizeGroups.find((prizeGroup) => prizeGroup.status !== 2);
      setPrizeGroup(prizeGroup);
    }

    // mission bottom sheet update
    const missionsContainer = document.getElementById("missions-container");
    if (missionsContainer) {
      missionsContainer.childNodes.forEach((child) => {
        ReactDOM.unmountComponentAtNode(child);
      });

      ReactDOM.render(
        MissionsBottomSheetContent({
          drawOpportunityCount: drawOpportunityCount,
          specialDrawOpportunityCount: specialDrawOpportunityCount,
          missions: missions,
          mission: onClickMission,
        }),
        missionsContainer,
      );
    }
  }

  function getGameWatermelonWithShareMissionComplete() {
    getGameWatermelon((data) => {
      const shareMission = data.benefit_event_missions.find(
        (mission) => mission.type === "1",
      );
      if (shareMission) {
        completeMission(shareMission);
      }
    });
  }

  function completeMission(mission) {
    if (mission?.id && getChipsUid()) {
      chipsApi.request({
        method: "post",
        url: `${domain}/api/v1/benefit-events/game_watermelon/missions/${mission.id}/complete`,
        then: (response) => {
          switch (response.data?.game_watermelon_status) {
            case "PARTICIPATED":
              // 이미 참여
              // 오전 도전권을 지급 받고 다시 오전 도전권 API를 호출한 경우
              return;

            case "AVAILABLE":
              trackEvent("gain_opportunity_popup");
              WatermelonPopup({
                title: "도전권 획득!",
                image:
                  "/games/fruits/assets/img-gain-opportunity-watermellon.png",
                message: `<span>
                                    도전권을 받았어요<br/>
                                    지금 바로 시작해보세요!
                                </span>`,
                close: () => {
                  trackEvent("gain_opportunity_close");
                  return false;
                },
                primaryButtonText: "확인",
                primaryButtonAction: () => {
                  trackEvent("gain_opportunity_ok");
                  return false;
                },
              });
              break;

            case "MAX_DRAW_OPPORTUNITY":
              trackEvent("share_max_draw_opportunity");
              WatermelonPopup({
                title: "도전권 안내",
                message: `<span>
                                    도전권은 최대 3개까지만<br/>
                                    보유할 수 있어요<br/>
                                    도전권 사용 후 다시 공유해보세요
                                </span>`,
                close: () => {
                  trackEvent("share_max_draw_opportunity_close");
                  return false;
                },
                primaryButtonText: "확인",
                primaryButtonAction: () => {
                  trackEvent("share_max_draw_opportunity_ok");
                  return false;
                },
              });
              break;

            case "MEMO_CHAT":
              trackEvent("share_memo_chat");
              WatermelonPopup({
                title: "본인 공유 불가",
                message: `<span>
                                    본인에게 공유할 수 없어요<br/>
                                    친구에게 공유해주세요!
                                </span>`,
                close: () => {
                  trackEvent("share_memo_chat_close");
                  return false;
                },
                secondaryButtonText: "확인",
                secondaryButtonAction: () => {
                  trackEvent("share_memo_chat_cancel");
                  return false;
                },
                primaryButtonText: "다시 공유하기",
                primaryButtonAction: () => {
                  trackEvent("share_memo_chat_ok");
                  shareKakao();
                  return false;
                },
              });
              break;

            case "ALREADY_SHARED":
              trackEvent("already_shared");
              WatermelonPopup({
                title: "중복 공유 불가",
                message: `<span>
                                    친구마다 1번씩만 공유할 수 있어요<br/>
                                    새로운 친구에게 공유해주세요!
                                </span>`,
                close: () => {
                  trackEvent("already_shared_close");
                  return false;
                },
                secondaryButtonText: "취소",
                secondaryButtonAction: () => {
                  trackEvent("already_shared_cancel");
                  return false;
                },
                primaryButtonText: "다시 공유하기",
                primaryButtonAction: () => {
                  trackEvent("already_shared_ok");
                  shareKakao();
                  return false;
                },
              });
              break;

            default:
              break;
          }

          getGameWatermelon();
        },
        error: (e) => {
          // const data = e.response?.data
          // const code = data?.code || -1
          // 2403
          //  이벤트 validation
          //  오전인데 오후 미션으로 요청하는 케이스
          // 2408
          //  참가 한 이벤트 미션이 없는 경우
          //  공유 하기가 완료된 미션 이거나
          //  공유 하기를 하지 않았을떄
          // return code === 2403 || code === 2408
          return true;
        },
      });
    }
  }

  function getLeaderBoard() {
    if (getChipsUid()) {
      chipsApi.request({
        method: "get",
        url: `${domain}/api/v1/benefit-events/game_watermelon/leaderboard/info`,
        then: (response) => {
          const data = response.data;
          LeaderboardPopup({
            leaderBoard: data,
            primaryButtonText: "확인",
            primaryButtonAction: () => {
              trackEvent("leaderboard_popup_ok");
              return false;
            },
          });
        },
      });
    } else {
      showLoginBottomSheet();
    }
  }

  function showWinnersPopup() {
    chipsApi.request({
      method: "get",
      url: `${domain}/api/v1/benefit-events/game_watermelon/winning_histories`,
      then: (response) => {
        const data = response.data;
        WinnersPopup({
          data: data,
          primaryButtonText: "확인",
          primaryButtonAction: () => {
            trackEvent("winners_popup_ok");
            return false;
          },
        });
      },
    });
  }

  function shareText() {
    // let link = window.location.origin
    // if (prizeGroups && prizeGroups.find((prizeGroup) => prizeGroup.id === 220)) {
    //     link += '/bridge/2'
    // } else {
    //     link += '/bridge/1'
    // }
    // link += `?referral_uid=${getChipsUid()}`

    // share('수박게임에 초대합니다!', link)

    let link = window.location.origin;
    link += "/bridge/3";
    link += `?referral_uid=${getChipsUid()}`;
    share("수박게임에 초대합니다!", link);
  }

  function shareKakao() {
    trackEvent("share");

    // eslint-disable-next-line no-undef
    const user = JSON.parse(chipsApp.getUserInfo());
    const userIdEnc = encryptText(user.id.toString());
    const referralUid = user.uid;
    const referralType = "game_watermelon";

    if (referralUid) {
      // eslint-disable-next-line no-undef
      Kakao.Share.sendCustom({
        templateId: 102556,
        templateArgs: {
          referral_uid: referralUid,
          referral_type: referralType,
        },
        serverCallbackArgs: {
          type: "benefit_event_game_watermelon",
          user_id_enc: userIdEnc,
          is_production: false,
        },
      });
    } else {
      showLoginBottomSheet();
    }
  }

  function playIntroImage(callback) {
    if (prizeGroup.popup_image_url) {
      trackEvent("intro_image");
      WatermelonImagePopup({
        image: prizeGroup.popup_image_url,
        secondaryButtonText: "닫기",
        secondaryButtonAction: () => {
          trackEvent("intro_image_close");
          return false;
        },
        primaryButtonText: "게임 시작하기",
        primaryButtonAction: () => {
          trackEvent("intro_image_ok");
          callback();
          return false;
        },
      });
    } else {
      callback();
    }
  }

  function play(consumed) {
    if (!consumed) {
      playIntroImage(() => {
        setTimeout(() => {
          play(true);
        }, 100);
      });
      return;
    }

    if (getChipsUid()) {
      const opportunityCount =
        prizeGroup.opportunity_type === "special"
          ? specialDrawOpportunityCount
          : drawOpportunityCount;
      if (prizeGroup.draw_value > opportunityCount) {
        trackEvent("not_enough_draw_opportunity");
        WatermelonPopup({
          title:
            prizeGroup.opportunity_type === "special"
              ? "스페셜 도전권 부족"
              : "도전권 부족",
          message:
            prizeGroup.opportunity_type === "special"
              ? `<span>
                            스페셜 도전권이 ${
                              prizeGroup.draw_value -
                              specialDrawOpportunityCount
                            }개가 더 필요해요<br/>
                            스페셜 도전권을 모아주세요!
                        </span>`
              : `<span>
                            도전권이 ${
                              prizeGroup.draw_value - drawOpportunityCount
                            }개 더 필요해요<br/>
                            도전권을 모아주세요!
                        </span>`,
          close: () => {
            trackEvent("not_enough_draw_opportunity_close");
            return false;
          },
          primaryButtonText: "도전권 모으기",
          primaryButtonAction: () => {
            trackEvent("not_enough_draw_opportunity_ok");
            setTimeout(() => {
              showMissionsBottomSheet();
              getGameWatermelon();
            }, 100);
            return false;
          },
        });
      } else if (prizeGroup.status === 0) {
        trackEvent("draw_limit_notice");

        // special 1회 제한은 즉시 지급으로 구분
        if (
          prizeGroup.opportunity_type === "special" &&
          prizeGroup.draw_limit === 1
        ) {
          WatermelonPopup({
            title: `${prizeGroup.name} 상품을 한번 받았어요`,
            message: `<span>
                                상품은 유저당 1번만 받을 수 있어요<br/>
                                다음 이벤트 때 상품을 받을 수 있어요.<br/>
                                <font color="#FF514E">
                                    상품을 받지 않고 게임을 시작할까요?
                                </font>
                            </span>`,
            secondaryButtonText: "다른 선물 받기",
            secondaryButtonAction: () => {
              trackEvent("draw_limit_notice_cancel");
              return false;
            },
            primaryButtonText: "게임 시작하기",
            primaryButtonAction: () => {
              trackEvent("draw_limit_notice_ok");
              TransferFruits.methods.play();
              return false;
            },
          });
        } else {
          WatermelonPopup({
            title: `${prizeGroup.name} 선물을 모두 받았어요`,
            message: `<span>
                                다른 선물도 매일 ${prizeGroup.draw_limit}번 받을 수 있어요<br/>
                                <font color="#FF514E">선물을 받지 않고 게임을 시작할까요?
                                </font>
                            </span>`,
            secondaryButtonText: "다른 선물 받기",
            secondaryButtonAction: () => {
              trackEvent("draw_limit_notice_cancel");
              return false;
            },
            primaryButtonText: "게임 시작하기",
            primaryButtonAction: () => {
              trackEvent("draw_limit_notice_ok");
              TransferFruits.methods.play();
              return false;
            },
          });
        }
      } else {
        trackEvent("play_notice");
        WatermelonPlayNoticePopup({
          title: "게임 참여 안내",
          image: prizeGroup.prize_items?.find((prize) => prize.type === 1)
            ?.image_url,
          message:
            prizeGroup.opportunity_type === "special"
              ? `<span>
                            ${prizeGroup.name}<br/>
                            선물을 선택하셨어요!<br/>
                            <font color="#FF514E">스페셜 도전권이 ${prizeGroup.draw_value}개 차감돼요</font>
                        </span>`
              : `<span>
                            ${prizeGroup.name}<br/>
                            선물을 선택하셨어요!<br/>
                            <font color="#FF514E">도전권이 ${prizeGroup.draw_value}개 차감돼요</font>
                        </span>`,
          secondaryButtonText: "취소",
          secondaryButtonAction: () => {
            trackEvent("play_notice_cancel");
            return false;
          },
          primaryButtonText: "게임 시작",
          primaryButtonAction: () => {
            trackEvent("play_notice_ok");
            TransferFruits.methods.play();
            return false;
          },
        });
      }
    } else {
      showLoginBottomSheet();
    }
  }

  const FINISH_MESSAGE = [
    '정말 대단해요!<br><span style="color: #000000;">상위 1%</span>의 실력을 갖고 있어요!',
    '<span style="color: #000000;">상위 5% 안에 들었다니!</span><br>축하드려요!',
    '자랑스러워요<br><span style="color: #000000;">상위 10%</span>안에 진입했어요',
    '<span style="color: #000000;">상위 20%</span>의 실력자에요<br>더 나아질 것 같아요!',
    "훌륭한 점수에요<br>점점 발전하고 있어요!",
    "잘했어요!<br>앞으로 더 나아질 수 있어요",
    "계속 도전하면<br>더 좋은 결과가 있을거에요!",
  ];

  const TransferFruits = {
    name: "TransferFruits",
    methods: {
      play() {
        setTimeout(() => {
          if (!localStorage.getItem("displayed_fruits_how_to")) {
            trackEvent("tutorial");
            WatermelonPopup({
              title: "게임 방법",
              image: "/games/fruits/assets/img-fruits-guide.png",
              message: `<span>
                                같은 과일끼리 붙여서<br/>
                                마지막 과일인 수박을 만들어보세요!
                            </span>`,
              primaryButtonText: "확인",
              primaryButtonAction: () => {
                trackEvent("tutorial_ok");
                localStorage.setItem("displayed_fruits_how_to", true);
              },
            });
          }
        }, 100);

        this.prepareAndSetup();
      },
      prepareAndSetup() {
        setShowGameOverLayer(false);
        setPlay(true);
        setLoaded(false);
        TransferFruits.isPlay = true;
        TransferFruits.playTime = 0;
        TransferFruits.verificationKey = "";
        TransferFruits.isSuccess = false;
        TransferFruits.isScoreMissionComplete = false;
        TransferFruits.prizeItem = null;
        setWaitingGameStart(true);
        this.setupC3();
      },

      async setupC3() {
        window.onLoadCompleteGameLayout = this.onLoadCompleteGameLayout;
        window.onChangedScore = this.onChangedScore;
        window.onSuccessGame = this.onSuccessGame;
        window.onFinishGame = this.onFinishGame;
        window.onTapObject = this.onTapObject;
        window.fruitsGravity = 54;

        try {
          if (window.c3canvas) {
            const target = document.getElementById("c3cont");
            target.appendChild(window.c3canvas);
          }

          this.c3RestartGames();
        } catch (e) {
          trackEvent("failed_initialize_c3");
          return false;
        }

        if (!window.C3_Is_Supported) {
          trackEvent("failed_c3_setup");
          try {
            // eslint-disable-next-line no-undef
            chipsApp.showToast("잠시 후 다시 시도해주세요");
          } catch (e) {}

          window.location.reload(true);
        }
      },
      async c3RestartGames() {
        if (!window.c3_callFunction) {
          return;
        }
        await window.c3_callFunction("restartGames");
      },
      onLoadCompleteGameLayout() {
        if (TransferFruits.isPlay) {
          setWaitingGameStart(false);
          setLoaded(true);
          TransferFruits.methods.c3EnableGames(true);

          TransferFruits.playTime = Date.now();
          // if (!this.isIOS) {
          // this.c3EnableNextFruits();
          // }
          // if (process.env.dev) {
          // window.c3_callFunction("enableDev");
          // }

          // Set easy mode
          window.c3_callFunction("setEasyMode");

          chipsApi.request({
            method: "post",
            url: `${domain}/api/v1/benefit-events/game_watermelon/participate`,
            data: { prize_group_id: prizeGroup.id },
            then: (response) => {
              const data = response.data;
              TransferFruits.verificationKey = data.verification_key;
            },
            error: (e) => {
              const data = e.response?.data;
              const attributes = {
                icon: "https://cdn.chips.today/logic/images/2023/09/19/1695113982488-f687da0b-f2ef-4920-b2c6-d78ef7d5e582.png",
                title: "알 수 없는 오류",
                body: "이용에 불편 드려 죄송합니다.\n잠시 후 다시 시도해 주세요!",
                secondary_button_text: "확인",
                secondary_button_style: "secondary",
                secondary_button_callback: "window.location.reload(true)",
              };

              if (data?.title || data?.message) {
                attributes.title = data.title;
                attributes.body = data.message;
              }
              try {
                // eslint-disable-next-line no-undef
                showBottomSheet(attributes);
              } catch (e) {}
              return true;
            },
          });
        }
      },
      c3EnableGames(enable) {
        if (!window.c3_callFunction) {
          return;
        }
        if (enable) {
          window.c3_callFunction("enableGames");
        } else {
          window.c3_callFunction("disableGames");
        }
      },
      async onChangedScore(score) {
        if (!TransferFruits.isScoreMissionComplete && score >= 300) {
          TransferFruits.isScoreMissionComplete = true;
          trackEvent("score_mission_complete", {
            score: score.toString(),
            duration: (Date.now() - TransferFruits.playTime).toString(),
            id: prizeGroup.id.toString(),
            title: prizeGroup.name,
          });
        }
      },
      async onSuccessGame(score) {
        if (TransferFruits.isSuccess) {
          return;
        }
        TransferFruits.isSuccess = true;

        trackEvent("success", {
          score: score.toString(),
          duration: (Date.now() - TransferFruits.playTime).toString(),
          id: prizeGroup?.id?.toString(),
          title: prizeGroup?.name,
        });

        setSuccessToast(true);
        setTimeout(() => {
          setSuccessToast(false);
        }, 3000);

        setGameOverTitle("수박 성공!");

        chipsApi.request({
          method: "post",
          url: `${domain}/api/v1/benefit-events/game_watermelon/complete`,
          data: {
            verification_key: TransferFruits.verificationKey,
            score: score,
            status: TransferFruits.isSuccess ? 2 : 3,
          },
          then: (response) => {
            const data = response.data;
            TransferFruits.prizeItem = data.prize_item;
          },
        });
      },
      async onFinishGame(score) {
        setGameScore(`점수: ${score}`);
        if (this.showGameOverLayer) {
          return;
        }

        // eslint-disable-next-line no-undef
        trackEvent("finish", {
          success: TransferFruits.isSuccess ? "true" : "false",
          score: score.toString(),
          duration: (Date.now() - TransferFruits.playTime).toString(),
          id: prizeGroup?.id?.toString(),
          title: prizeGroup?.name,
        });

        this.showGameOverLayer = true;
        setShowGameOverLayer(true);

        let finishMessage;

        if (score > 5552) {
          finishMessage = FINISH_MESSAGE[0];
        } else if (score > 4339) {
          finishMessage = FINISH_MESSAGE[1];
        } else if (score > 4138) {
          finishMessage = FINISH_MESSAGE[2];
        } else if (score > 3919) {
          finishMessage = FINISH_MESSAGE[3];
        } else if (score > 3294) {
          finishMessage = FINISH_MESSAGE[4];
        } else if (score > 1772) {
          finishMessage = FINISH_MESSAGE[5];
        } else {
          finishMessage = FINISH_MESSAGE[6];
        }

        const myBestScore = localStorage.getItem("my_best_fruits_score") || "0";
        if (parseInt(myBestScore) < score) {
          localStorage.setItem("my_best_fruits_score", score);
          finishMessage = `와우! 지금까지 중에 가장 높은 점수에요!<br>${finishMessage}`;
        }

        document.querySelector(".game-over-message span").innerHTML =
          finishMessage;

        const drawPrize = TransferFruits.prizeItem;
        if (drawPrize) {
          if (drawPrize.draw_image_url) {
            WatermelonImagePopup({
              image: prizeGroup.draw_image_url,
            });

            setTimeout(() => {
              window.history.back();
              setTimeout(() => {
                WatermelonPopup({
                  title: "수박 만들기 성공",
                  image: drawPrize?.image_url,
                  message: `<span>${drawPrize?.winning_phrase}</span>`,
                  close: () => {
                    trackEvent("draw_prize_close");
                    return false;
                  },
                  primaryButtonText: "확인",
                  primaryButtonAction: () => {
                    trackEvent("draw_prize_ok");
                  },
                });
              }, 100);
            }, 2000);
          } else {
            WatermelonPopup({
              title: "수박 만들기 성공",
              image: drawPrize?.image_url,
              message: `<span>${drawPrize?.winning_phrase}</span>`,
              close: () => {
                trackEvent("draw_prize_close");
                return false;
              },
              primaryButtonText: "확인",
              primaryButtonAction: () => {
                trackEvent("draw_prize_ok");
              },
            });
          }
        }

        if (TransferFruits.isSuccess) {
          chipsApi.request({
            method: "post",
            url: `${domain}/api/v1/benefit-events/game_watermelon/after_complete`,
            data: {
              score: score,
              status: 10,
            },
            error: (e) => {
              return true;
            },
          });
        }
      },
      onTapObject(obj) {
        if (this.showGameOverLayer) {
          return;
        }
        if (obj === "quitGame") {
          trackEvent("quit_game");
          WatermelonPopup({
            title: "게임 그만하기",
            message: `<span>
                                진행상황이 모두 사라져요<br/>
                                정말 그만할까요?
                            </span>`,
            close: () => {
              trackEvent("quit_game_close");
              TransferFruits.methods.c3EnableGames(true);
              return false;
            },
            secondaryButtonText: "계속하기",
            secondaryButtonAction: () => {
              trackEvent("quit_game_cancel");
              TransferFruits.methods.c3EnableGames(true);
              return false;
            },
            primaryButtonText: "그만하기",
            primaryButtonAction: () => {
              trackEvent("quit_game_ok");
              setTimeout(() => {
                window.location.reload();
              }, 100);
              return false;
            },
          });
        }
      },
    },
  };

  return (
    <div className="Fruits">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />

      <div
        className="intro-container scrollbar-hidden"
        style={{
          visibility: !isPlay ? "visible" : "hidden",
          paddingTop: getInsetTop(),
        }}
      >
        <div style={{ width: "100%", position: "absolute" }}>
          <div
            className="back-button-container"
            onClick={() => {
              try {
                // eslint-disable-next-line no-undef
                chipsApp.close();
              } catch (e) {}
            }}
          >
            <img
              className="img-back-button"
              src="/games/fruits/assets/ic-back.png"
            />
          </div>
          <div
            className="fruits-intro-bg"
            style={{
              paddingTop: getInsetTop(),
              top: `-${getInsetTop()}`,
            }}
          ></div>
          <div className="fruits-intro-circle-bg"></div>

          <div className="header-buttons-container">
            <div
              className="leader-board"
              onClick={() => {
                trackEvent("leaderboard");
                getLeaderBoard();
              }}
            >
              <img
                className="img-leader-board"
                src="/games/fruits/assets/rank_icon_26.png"
              />
              <span>랭킹 보기</span>
            </div>

            <span className="bar" />

            <div
              className="winners"
              onClick={() => {
                trackEvent("winners");
                showWinnersPopup();
              }}
            >
              <span>당첨자 내역</span>
            </div>
          </div>
        </div>

        <div className="content">
          <img
            src={isEndedEvent ? '/games/fruits/assets/img-fruits-logo-finish.png' : '/games/fruits/assets/img-fruits-headline.png'}
            className="img-fruits-headline"
          />
          {
            !isEndedEvent && (
              <img
                src="/games/fruits/assets/img-fruits-headline-text.png"
                className="img-fruits-headline-text"
              />
            )
          }

          {
            isEndedEvent ? (
              <div className="service-unavailable-cont">
                <div className="service-content sp14body2black100Regular">
                  <div>안녕하세요. 칩스팀입니다.</div>
                  <div>
          <span style={{
            fontWeight: "bold",
          }} className="sp14body2black100Bold">
            수박 게임 기능은 2월 1일부로 종료
          </span>
                    되었습니다.
                  </div>

                  <br />

                  <div>더 다양한 미니게임은</div>
                  <div>게임마당에서 즐기실 수 있습니다.</div>

                  <br />

                  <div style={{
                    fontWeight: "bold",
                    display: "inline-block",
                  }}  className="sp14body2black100Bold">
                    수박게임과 유사한
                    <span  style={{ color: "#DD6A00" }}>&nbsp;"데굴데굴 동물농장"</span>에서
                  </div>
                  <div style={{
                    display: "inline-block",
                  }}>
                    <span  style={{
                      fontWeight: "bold",
                    }} className="sp14body2black100Bold">계속해서 플레이</span>&nbsp;하실 수 있습니다!
                  </div>

                  <div style={{
                    fontWeight: "bold",
                  }}>감사합니다.</div>
                </div>

                <button onClick={handleMoveGame} className="img-cont" type="button">
                  <img
                    src="/games/fruits/assets/img-fruits-transfer.png"
                    className="img-fruits-transfer"
                    alt=""
                  />
                </button>
              </div>
            ) : prizeGroups?.length > 0 ? (
              <PrizeGroups
                prizeGroups={prizeGroups}
                selectedPrizeGroup={prizeGroup}
                onPrizeGroupClick={(nextPrizeGroup) => {
                  trackEvent("prize_group", {
                    id: nextPrizeGroup.id.toString(),
                    title: nextPrizeGroup.name,
                  });
                  setPrizeGroup(nextPrizeGroup);
                }}
              />
            ) : null
          }
        </div>
        {
          !isEndedEvent && (
            <div className="bottom-container">
              <div className="draw-opportunity-container">
                <div style={{
                  width: '100%',
                  textAlign: 'center',
                  fontFamily: 'OneMobilePop',
                  fontSize: 'calc(var(--nbt-width) * 14 / var(--nbt-canvas-width))',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '150%',
                }}>수박게임 기능은 2월 1일부터 이용이 종료됩니다
                </div>
              </div>
              {winningDisplays && winningDisplays.length > 0 ? (
                <WinnersDisplay winners={winningDisplays} />
              ) : null}
              <div className="draw-opportunity-container">
                <div className="draw-opportunity-title">내 도전권</div>
                <img
                  className="draw-opportunity-icon"
                  src="/games/fruits/assets/ic-fruits-ticket-special.png"
                />
                <div className="draw-opportunity-count-special">
                  {specialDrawOpportunityCount}개
                </div>
                <img
                  className="draw-opportunity-icon"
                  src="/games/fruits/assets/ic-fruits-ticket.png"
                />
                <div className="draw-opportunity-count">
                  {drawOpportunityCount}개
                </div>
                <div
                  className="draw-opportunity-missions"
                  onClick={() => {
                    trackEvent("missions");
                    showMissionsBottomSheet();
                    getGameWatermelon();
                  }}
                >
                  도전권 모으기
                </div>
              </div>

              <div className="game-start-container">
                {/*<div*/}
                {/*  className="participate-history"*/}
                {/*  onClick={() => {*/}
                {/*    trackEvent("participate_history");*/}
                {/*    if (getChipsUid()) {*/}
                {/*      chipsApi.request({*/}
                {/*        method: "get",*/}
                {/*        url: `${domain}/api/v1/benefit-events/game_watermelon/user/histories`,*/}
                {/*        then: (response) => {*/}
                {/*          const data = response.data;*/}
                {/*          DrawHistoriesPopup({*/}
                {/*            histories: data.benefit_event_user_histories,*/}
                {/*            participateCount: data.participate_count,*/}
                {/*            primaryButtonText: "확인",*/}
                {/*            primaryButtonAction: () => {*/}
                {/*              trackEvent("participate_history_ok");*/}
                {/*              return false;*/}
                {/*            },*/}
                {/*          });*/}
                {/*        },*/}
                {/*      });*/}
                {/*    } else {*/}
                {/*      showLoginBottomSheet();*/}
                {/*    }*/}
                {/*  }}*/}
                {/*>*/}
                {/*  내 응모 현황*/}
                {/*</div>*/}
                <div
                  className="game-start"
                  onClick={() => {
                    trackEvent("play", {
                      id: prizeGroup.id.toString(),
                      title: prizeGroup.name,
                    });
                    play();
                  }}
                >
                  게임 시작하기
                </div>
              </div>
            </div>
          )
        }

      </div>

      <div
        className="play-container"
        style={{
          display: isPlay ? "block" : "none",
        }}
      >
        <div
          id="canvas-container"
          style={{
            width: "100vw",
            height: "100vh",
            position: "absolute",
          }}
        >
          <div id="c3cont" />
        </div>

        <div
          className="loading-container"
          style={{ visibility: !isLoaded ? "visible" : "hidden" }}
        >
          <div className="loading-content">
            <img
              src="/games/fruits/assets/gif-fruits-loading-min.gif"
              className="gif-fruits-loading-min"
            />
            <img
              src="/games/fruits/assets/img-fruits-loading.png"
              className="img-fruits-loading"
            />
          </div>
        </div>

        <div
          className="fruits-success-toast-container"
          style={{ visibility: isSuccessToast ? "visible" : "hidden" }}
        >
          <div>
            <span>수박 만들기 성공!</span>
            <span
              style={{
                display: prizeGroup.prize_items?.find(
                  (prize) => prize.type === 1,
                )
                  ? "block"
                  : "none",
              }}
            >
              게임이 끝나면 <font color="#FF8A00">랜덤 선물</font> 받아요
            </span>
            <span
              style={{
                display: prizeGroup.prize_items?.find(
                  (prize) => prize.type === 1,
                )
                  ? "none"
                  : "block",
              }}
            >
              게임이 끝나면 <font color="#FF8A00">이벤트 응모가 완료</font>돼요
            </span>
          </div>
        </div>

        <div
          className="game-over-container"
          style={{ visibility: isShowGameOverLayer ? "visible" : "hidden" }}
        >
          <OutlineText
            className="game-over-title"
            text={gameOverTitle}
            webkitTextStroke={`${calc(6)} #000`}
          />
          <OutlineText
            className="game-over-score"
            text={gameScore}
            webkitTextStroke={`${calc(6)} #000`}
          />

          <div className="game-over-message">
            <span></span>
          </div>

          <div
            className="game-over-return"
            onClick={() => {
              trackEvent("game_over_return");
              window.location.reload();
            }}
          >
            돌아가기
          </div>
        </div>
      </div>

      <ChipsPopupContainer />
    </div>
  );
}

function showLoginBottomSheet() {
  trackEvent("login_required");

  const attributes = {
    icon: "https://cdn.chips.today/logic/barcode/zips/2024/03/18/1710756901611-0bbd476e-3c68-4a11-8500-7d2ee5f24624.png",
    title: "로그인/회원가입을 해주세요!",
    body: "로그인하고 칩스를 시작하세요.<br>지금 가입하면 신규 회원 혜택 600원까지!",
    secondary_button_text: "취소",
    primary_button_text: "시작하기",
    primary_button_callback: "moveToLogin()",
  };
  try {
    // eslint-disable-next-line no-undef
    chipsApp.showLoginBottomSheet(JSON.stringify(attributes));
  } catch (e) {}
}

export default Fruits;
